var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    attrs: {
      "className": "header--light"
    }
  }, [_c('sub-visual-office', {
    attrs: {
      "sh": "본사",
      "shRe": "지점",
      "bg": "/images/sub/visual/sv1-3.jpg",
      "link": "/introduction/branch",
      "linkText": "지점이 궁금하다면?"
    }
  }, [_c('p', [_vm._v(" 해외 지사와 함께 소통하며 세일즈 및 구독 서비스 분야에 특화된 데이터와 글로벌 역량을 바탕으로 고객사에게 차별화된 맞춤형 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 솔루션을 제공합니다. ")]), _c('p', [_vm._v(" 또한 지점에서 활동하는 브랜드 홍보대사와 펀드레이저가 최상의 환경에서 높은 성과를 낼 수 있도록 다방면으로 지원합니다. ")])]), _c('section', {
    staticClass: "section bg-grey map-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "org-rotate-wrap d-none d-lg-block mt-lg-n134 mb-lg-n146 mx-auto",
    attrs: {
      "data-aos": "zoom-in-up"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/sub/about/office/org-pc.png",
      "max-width": "1002"
    }
  }), _c('v-img', {
    staticClass: "org-rotate",
    attrs: {
      "src": "/images/sub/about/office/org-pc-rotate.png",
      "max-width": "1002"
    }
  })], 1), _c('v-img', {
    staticClass: "mx-auto d-block d-lg-none",
    attrs: {
      "src": "/images/sub/about/office/org.png",
      "max-width": "951",
      "data-aos": "zoom-in-up"
    }
  })], 1)], 1), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold"
  }, [_vm._v(" 세일즈웍스 코리아 본사의 기업 문화와 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 다양한 복지를 소개합니다. ")])]), _c('div', {
    staticClass: "mb-50 mb-lg-100"
  }, [_c('h5', {
    staticClass: "bar-text mb-30"
  }, [_vm._v(" 기업 문화 ")]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('image-item', {
    attrs: {
      "src": "/images/sub/about/office/s2-img1-1.jpg",
      "sc1": "안전하고 스마트하게",
      "sc2": "재택근무"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('image-item', {
    attrs: {
      "src": "/images/sub/about/office/s2-img1-2.jpg",
      "sc1": "매주 수요일은 단축근무",
      "sc2": "주 4.5일 근무"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('image-item', {
    attrs: {
      "src": "/images/sub/about/office/s2-img1-3.jpg",
      "sc1": "내가 선택하는 출퇴근시간",
      "sc2": "탄력근무제"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('image-item', {
    attrs: {
      "src": "/images/sub/about/office/s2-img1-4.jpg",
      "sc1": "매주 수·금요일은 캐주얼데이",
      "sc2": "자율복장"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('image-item', {
    attrs: {
      "src": "/images/sub/about/office/s2-img1-5.jpg",
      "sc1": "5년 근속 시 포상금",
      "sc2": "장기근속자 포상"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('image-item', {
    attrs: {
      "src": "/images/sub/about/office/s2-img1-6.jpg",
      "sc1": "분기마다 서로를 칭찬하는 시간",
      "sc2": "우수사원 포상"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('image-item', {
    attrs: {
      "src": "/images/sub/about/office/s2-img1-7.jpg",
      "sc1": "내 휴가는 내가 정한다",
      "sc2": "자유로운 연차 사용"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('image-item', {
    attrs: {
      "src": "/images/sub/about/office/s2-img1-8.jpg",
      "sc1": "우리 아이가 태어날 때",
      "sc2": "배우자 출산휴가"
    }
  })], 1)], 1)], 1), _c('div', [_c('h5', {
    staticClass: "bar-text mb-30"
  }, [_vm._v(" 복지 제도 ")]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('image-item', {
    attrs: {
      "src": "/images/sub/about/office/s2-img2-1.jpg",
      "sc1": "안전하고 건강하게",
      "sc2": "4대보험"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('image-item', {
    attrs: {
      "src": "/images/sub/about/office/s2-img2-2.jpg",
      "sc1": "회사가 주는 생일선물",
      "sc2": "유급 생일 휴가"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('image-item', {
    attrs: {
      "src": "/images/sub/about/office/s2-img2-3.jpg",
      "sc1": "아프면 쉬어가요",
      "sc2": "유급 병가"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('image-item', {
    attrs: {
      "src": "/images/sub/about/office/s2-img2-4.jpg",
      "sc1": "일도 중요하지만 건강이 우선",
      "sc2": "의료비 지원"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('image-item', {
    attrs: {
      "src": "/images/sub/about/office/s2-img2-5.jpg",
      "sc1": "기쁨과 슬픔 모두 함께",
      "sc2": "각종 경조사 지원"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('image-item', {
    attrs: {
      "src": "/images/sub/about/office/s2-img2-6.jpg",
      "sc1": "야근이 힘들지 않게",
      "sc2": "야근 수당 & 식대 및 교통비 지원"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('image-item', {
    attrs: {
      "src": "/images/sub/about/office/s2-img2-7.jpg",
      "sc1": "풍성하고 행복한 명절",
      "sc2": "명절 상품권 지급"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('image-item', {
    attrs: {
      "src": "/images/sub/about/office/s2-img2-8.jpg",
      "sc1": "분기마다 함께하는 시간",
      "sc2": "부서별 회식비 지원"
    }
  })], 1)], 1)], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }